import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../api';
import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import CaseTableHeader from "./case-table-header";
import CaseTableRow from "./case-table-row";
import {from} from "linq";
import {DateFilter} from "../../components/table/filters/date-filter";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import ReactGA from 'react-ga';
import CreateCase from './create-case';
import { AuthService } from '../../services/auth-service'



function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}

class ServiceManagementTab extends Component {
    state = {
        dataProvider: new ApiDataProvider(api.getCaseList, [this.props.customerId,this.props.siteKey,this.props.meterSiteKey,"false"]),
        queriesList: [],
        netSavings: 0,
        totalQueries: 0,
        totalClosedQueries: 0,
        totalPendingQueries: 0,

    }

    calculateNetSavings(cases) {
        return from(cases)
            .sum(x => x.netSaving).toFixed(2);
    }

    countStatus(cases, status) {
        return from(cases)
            .count(x => x.status === status);
    }

    handleChartClick = (e) => {
        if(e.length !== 0)
        {
                var label = e[0]._view.label
               

                this.filterableDataTableRef.onAdvancedFilterChange({
                    QueryType: label,
                    Status:  "In Progress"
                });

              
        }else
        {
            this.filterableDataTableRef.onAdvancedFilterChange({
                QueryType: "",
                Status:  ""
            });
        }
      };

      
      

    render() {
        const authServices = new AuthService();

        return (
            <div className='main-container'>
                
                <Grid padded stackable columns='equal'>
                    
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Cases</h2>
                        </Grid.Column>

                    </Grid.Row>
                    <Grid.Row>
                    <Grid.Column>
                    {(authServices.hasCaseManActive(this.props.customerId)) &&

                    <CreateCase assetLabel={this.props.caseLabel} siteKey={this.props.siteKey} meterSiteKey={this.props.meterSiteKey}  utility={this.props.utility}></CreateCase>
                    }
                        
                        </Grid.Column>

                    </Grid.Row>
                    <Grid.Row>
                   
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider}    ref={(ref) => (this.filterableDataTableRef = ref)} 
                               
                                
                                filterComponent={DateFilter} name="cases" canExport={false} storeName="caseList" clearStore={ this.getStoreageRule() }
                                                     headerComponent={CaseTableHeader} rowComponent={CaseTableRow}
                                                      defaultSort={"caseNumber"}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
    componentDidMount = () => {
        this.fetchData();
        ReactGA.pageview('case management');
    }

    getStoreageRule() {
        try 
        {
           
           return  this.props.location.state.clearStore; // better way to check undefined but i'm going mad today
         } catch
          {
              return false
          }
       }

    fetchData = () => {
        return Promise.all([
            api.getCaseList(this.props.customerId, this.props.siteKey, this.props.meterSiteKey,"false")
        ])
        .then(([queriesList]) =>
            this.setState({
                queriesList: queriesList.data,
                totalQueries: queriesList.data.length,
                totalClosedQueries: this.countStatus(queriesList.data,"Closed"),
                totalPendingQueries: this.countStatus(queriesList.data,"In Progress"),
                netSavings: this.calculateNetSavings(queriesList.data)
            }))
    }

    componentDidUpdate = () => {
    }

}

const wrap = connect(mapStateToProps, mapDispatchToProps);
export default wrap(ServiceManagementTab);